import MUIFormGroup from "@mui/material/FormGroup"
import React from "react"

export type FormGroupProps =
  | ({ new?: false } & React.ComponentProps<typeof MUIFormGroup>)
  | ({ new: true } & unknown)

export const FormGroup: React.FC<FormGroupProps> = ({ ...props }) =>
  props.new ? null : <MUIFormGroup {...props} />

export default FormGroup
